var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-x grid-margin-x card-list"},_vm._l((_vm.contentItem.items),function(item,index){return _c('div',{key:index,staticClass:"cell medium-4 card"},[_c('div',{staticClass:"card__title",domProps:{"innerHTML":_vm._s(item.title)}}),_c('div',{staticClass:"card__image"},[_c('img',{attrs:{"src":item.image,"alt":""}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }